<template>
  <div>
    <Card
      icon="clock"
      title="History"
    >
      <History
        v-if="history.length"
        :items="history"
      />
      <span v-if="!history.length">No history items to show</span>
    </Card>
  </div>
</template>

<script>
import Card from '../components/Card'
import History from '../components/History'
import { mapState } from 'vuex'

export default {
  components: {
    Card,
    History
  },
  computed: mapState({
    history: state => state.manageCampaigns.campaign.history
  }),
  mounted () {
    if (this.$route.query.campaignId) {
      this.$store.dispatch('setCampaignHistory', { projectId: this.$route.query.campaignId, userEmail: this.$route.query.userEmail })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
